import React, { Fragment, useEffect, useState } from 'react'; 
import Navbar from '../../Components/Main/Navbar';
import SocialMedia from '../../Components/Main/SocialMedia';
import '../../CSS/main.scss';

const Main = ({children})=> { 
  const socialMediaObject = {
    facebook: "https://www.facebook.com/TheChiran/",
    linkedIn: "https://www.linkedin.com/in/tonmoy-chiran-0920b2151/",
    gitHub: "https://github.com/TheChiran",
    twitter: "https://twitter.com/ChiranTonmoy",
    instagram: "https://www.instagram.com/chiran_swe/"
  }
  return (
      <Fragment>
        <div className="main" id="main">
          <div className="scroll-to-top">
          <a href="#main">
            <div className="scroll-icon-div" href="">
              <span className="icon">
                <a href="#main">
                  <i class="fas fa-arrow-up"></i>
                </a>
              </span>
            </div>
          </a>
          </div>
          <div className="navbar-content">
              <Navbar/>
          </div>
          <div className="pages">
              {children}
          </div>
          <div className="social-media">
            <SocialMedia social = {socialMediaObject}/>
          </div>
      </div>
      </Fragment>
  );
}

export default Main; 